<div class="main-content" [style.background-color]="viewModel.cardColor$ | async">
  <app-print-card-background-image-with-color-overlay-and-opacity [cardBackground]="cardBackground">
  </app-print-card-background-image-with-color-overlay-and-opacity>
</div>
<div
  class="color-strip"
  [style.width]="viewModel.colorStripWidth$ | async"
  [style.background-color]="viewModel.cardAccentColor$ | async"></div>
